import React from "react";

import withStyles from "@material-ui/styles/withStyles";

import {
  List,
  Filter,
  ReferenceInput,
  SelectInput,
  ReferenceField,
  FunctionField,
  TextField,
  Datagrid,
  ShowButton,
  EditButton,
  CreateButton,
  FilterButton,
} from "jazasoft";
import { Role } from "../../utils/types";

const filters = (roles) => (
  <Filter>
    <ReferenceInput
      label="App"
      resource="apps"
      source="appId"
      reference="apps"
      pageSize={100}
      sort={{ field: "name", order: "asc" }}
      xs={12}
      fullWidth
      options={{ fullWidth: true }}
    >
      <SelectInput />
    </ReferenceInput>
    {roles.includes(Role.MASTER) && (
      <ReferenceInput
        label="Tenant"
        resource="tenants"
        source="tenantId"
        reference="tenants"
        pageSize={100}
        sort={{ field: "name", order: "asc" }}
        xs={12}
        fullWidth
        options={{ fullWidth: true }}
      >
        <SelectInput />
      </ReferenceInput>
    )}
  </Filter>
);

const homeStyle = (theme) => ({
  buttonEdit: {
    width: theme.spacing(14),
  },
  buttonDelete: {
    width: theme.spacing(16),
  },
});

export default withStyles(homeStyle)(({ classes, ...props }) => {
  const roles = props.roles || [];
  return (
    <List
      filters={roles.includes(Role.MASTER) || roles.includes(Role.SUPER_USER) ? filters(roles) : null}
      actions={({ basePath, resource }) => (
        <div>
          {roles.includes(Role.MASTER) && <CreateButton basePath={basePath} showLabel={false} />}
          {(roles.includes(Role.MASTER) || roles.includes(Role.SUPER_USER)) && <FilterButton showLabel={false} resource={resource} />}
        </div>
      )}
      parse={({ appId, tenantId }) => ({
        "app.id": appId,
        "tenant.id": tenantId,
      })}
      {...props}
    >
      <Datagrid>
        <TextField source="name" />
        {(roles.includes(Role.MASTER) || roles.includes(Role.SUPER_USER)) && (
          <ReferenceField source="appId" reference="apps" allowEmpty>
            <TextField source="name" />
          </ReferenceField>
        )}
        {roles.includes(Role.MASTER) && (
          <ReferenceField source="tenantId" reference="tenants" allowEmpty>
            <TextField source="name" />
          </ReferenceField>
        )}
        {roles.includes(Role.MASTER) && <FunctionField label="Default" render={(record) => (record.isDefault === true ? "Yes" : "No")} />}
        <TextField source="desc" />
        <ShowButton cellClassName={classes.buttonEdit} />
        {roles.includes(Role.MASTER) && <EditButton cellClassName={classes.buttonEdit} />}
      </Datagrid>
    </List>
  );
});
